import { useSignIn, useSignUp } from '@clerk/clerk-react'
import { isApp, openLink } from '@/helpers'
import { BASE_URL } from '@/constants'
import {urlJoin} from "@/helpers/utils";

interface OAuthParams {
  redirectUrl?: string
}

interface StartOAuthFlowParams {
  provider: {
    strategy: string
  }
  redirectUrl?: string
}

export function useOAuth(useOAuthParams?: OAuthParams) {
  const { signIn, setActive, isLoaded: isSignInLoaded } = useSignIn()
  const { signUp, isLoaded: isSignUpLoaded } = useSignUp()

  async function startOAuthFlow(startOAuthFlowParams: StartOAuthFlowParams) {
    if (!isSignInLoaded || !isSignUpLoaded) {
      return {
        createdSessionId: '',
        signIn,
        signUp,
        setActive
      }
    }

    const { strategy } = startOAuthFlowParams.provider

    const app = isApp()
    const redirectUrl = startOAuthFlowParams?.redirectUrl ||
      useOAuthParams?.redirectUrl ||
      (app ? `https://profile.gameglass.gg/sso/app` : urlJoin(window.location.origin, BASE_URL, '/sso-callback'))

    if (app) {
      openLink(`https://profile.gameglass.gg/sso/app/${strategy}?${new URLSearchParams({ redirectUrl, timestamp: String(Date.now()) })}`, true, '_self')
    } else {
      await signIn!.create({
        strategy: strategy as any,
        redirectUrl
      })

      const { externalVerificationRedirectURL } = signIn!.firstFactorVerification as any

      if (externalVerificationRedirectURL) {
        openLink(externalVerificationRedirectURL.toString(), true, '_self')
      }
    }
  }

  return {
    startOAuthFlow
  }
}
